// ============================================================
// Super Admin Navigation Configuration
// ============================================================
// Config-driven sidebar menu for Super Admin.
// Items are filtered at runtime based on user permissions.

import {
  LayoutDashboard,
  Building2,
  School,
  Blocks,
  ShieldCheck,
  Users,
  FileText,
  Settings,
} from 'lucide-react';
import { PERMISSIONS } from './permissions';
import { PATHS } from '@/router/paths';

export const superAdminNavigationConfig = [
  {
    id: 'super-admin-dashboard',
    title: 'Dashboard',
    path: PATHS.SUPER_ADMIN_DASHBOARD,
    icon: LayoutDashboard,
    permission: PERMISSIONS.SUPER_ADMIN_ACCESS,
  },
  {
    id: 'super-admin-organizations',
    title: 'Organizations',
    path: PATHS.SUPER_ADMIN_ORGANIZATIONS,
    icon: Building2,
    permission: PERMISSIONS.SUPER_ADMIN_ACCESS,
  },
  {
    id: 'super-admin-schools',
    title: 'Schools',
    path: PATHS.SUPER_ADMIN_SCHOOLS,
    icon: School,
    permission: PERMISSIONS.SUPER_ADMIN_ACCESS,
  },
  {
    id: 'super-admin-modules',
    title: 'Module Assignment',
    path: PATHS.SUPER_ADMIN_MODULES,
    icon: Blocks,
    permission: PERMISSIONS.SUPER_ADMIN_ACCESS,
  },
  {
    id: 'super-admin-role-access',
    title: 'Role Permissions',
    path: PATHS.SUPER_ADMIN_ROLE_ACCESS,
    icon: ShieldCheck,
    permission: PERMISSIONS.SUPER_ADMIN_ACCESS,
  },
  {
    id: 'super-admin-users',
    title: 'Users',
    path: PATHS.SUPER_ADMIN_USERS,
    icon: Users,
    permission: PERMISSIONS.SUPER_ADMIN_ACCESS,
  },
  {
    id: 'super-admin-reports',
    title: 'Reports',
    path: PATHS.SUPER_ADMIN_REPORTS,
    icon: FileText,
    permission: PERMISSIONS.SUPER_ADMIN_ACCESS,
  },
  {
    id: 'super-admin-settings',
    title: 'Settings',
    path: PATHS.SUPER_ADMIN_SETTINGS,
    icon: Settings,
    permission: PERMISSIONS.SUPER_ADMIN_ACCESS,
  },
];
